'use strict';

module.exports = {
  resultTypes: require('./src/resultTypes'),
  client: require('./src/searchInterface')
};